import types from './actionTypes'

const initialState = {
  isLoading: false,
  dataList: [],
  currentPage: 1,
  pageCount: 1
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case types.LOAD_DATA:
      return {
        ...state,
        isLoading: true,
        currentPage: action.data
      }
    case types.LOAD_DATA_COMPLETE:
      return {
        ...state,
        isLoading: false,
        dataList: action.data.results,
        pageCount: action.data.count
      }
    case types.DELETE_ADMIN_DATA:
      return {
        ...state,
        isLoading: true
      }
    case types.DELETE_ADMIN_COMPLETE:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/Management/Admin/store/reducers.js